module.exports = __webpack_public_path__ + "img/blue_under_attack_2.10901ea4.png";